<swiper-container
  #swiper
  init = "false"
>
  <swiper-slide
    *ngFor="let face of faces"
    (click)="flipCard($event)"
  >
    <ng-template [ngTemplateOutlet]="face.template"></ng-template>
  </swiper-slide>
</swiper-container>
